@import '../../../../../../../src/constants/spacing.module.less';
@import '../../../../../../../src/constants/screen-width-breakpoints.module.less';

.phone-number-step {
  max-width: 835px;
  margin: @space-0 auto @space-64;
  text-align: left;

  @media @mobile, @ultramobile {
    margin-bottom: @space-24;
  }
}

.phone-number-step-header {
  text-align: left;
  margin-bottom: @space-24;
}

.header {
  font-weight: 700;
  margin: @space-0 @space-0 @space-8;
}

.form-card {
  padding: @space-24 @space-24 @space-32;
  background-color: var(--white);
  border-radius: 8px;
  border: 1px solid var(--gray-E4E5E7);
}

.form-content {
  width: 100%;
  max-width: 400px;
}
